/*
 * Comportamenti delle sezioni mk-* ricostruite da PageFly (Ennovative 10-2026):
 * slider (frecce, pallini, autoplay), galleria prodotto con miniature, FAQ, bottoni "vai alla sezione".
 * Nessuna dipendenza da PageFly: lavora sulle stesse classi che il CSS copiato si aspetta.
 */
(function () {
  'use strict';
  if (window.__mkPf) return;
  window.__mkPf = true;

  function opzioni(el) {
    var radice = el.closest('[data-mk-slider]');
    try { return radice ? JSON.parse(radice.getAttribute('data-mk-slider')) || {} : {}; } catch (e) { return {}; }
  }

  // ---------- slider ----------
  function slider(track) {
    if (track.__mk) return;
    track.__mk = true;
    var media = track.classList.contains('pf-media-slider');
    var selSlide = track.classList.contains('pf-media-slider')
      ? (track.querySelector('.pf-slide-list-media') ? '.pf-slide-list-media' : '.pf-slide-main-media')
      : '.pf-slide';
    var slides = Array.prototype.filter.call(track.children, function (c) { return c.matches(selSlide); });
    if (!slides.length) return;
    var opt = opzioni(track);
    // frecce e pallini: dentro lo slider (Slideshow, ContentList) o accanto (galleria)
    function cerca(sel) {
      return track.querySelector(':scope > ' + sel) || track.parentElement.querySelector(':scope > ' + sel);
    }
    var prev = cerca('.pf-slider-prev');
    var next = cerca('.pf-slider-next');
    var nav = cerca('.pf-slider-nav');

    track.classList.add('has-loaded');
    if (media) track.style.scrollSnapType = 'x mandatory';
    slides.forEach(function (s) { s.setAttribute('tabindex', '-1'); s.style.scrollSnapStop = 'always'; });

    function passo() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth; }
    function perVista() { var p = passo(); return p > 0 ? Math.max(1, Math.round(track.clientWidth / p)) : 1; }
    function pagine() { return Math.max(1, slides.length - perVista() + 1); }
    function indice() { var p = passo(); return p > 0 ? Math.round(track.scrollLeft / p) : 0; }

    var pallini = [];
    function costruisciPallini() {
      if (!nav) return;
      nav.innerHTML = '';
      pallini = [];
      for (var i = 0; i < pagine(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { vai(k); }); })(i);
        nav.appendChild(b);
        pallini.push(b);
      }
    }

    function aggiorna() {
      var i = indice(), n = pagine(), pv = perVista();
      slides.forEach(function (s, k) {
        s.classList.toggle('is-current', k === i);
        s.classList.toggle('is-visible', k >= i && k < i + pv);
        if (media) s.setAttribute('data-active', k === i ? 'true' : 'false');
        if (!media) { if (k >= i && k < i + pv) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); }
      });
      pallini.forEach(function (b, k) { b.classList.toggle('active', k === i); });
      // "altezza della slide corrente" (maxHeight: false in PageFly): lo slider segue la slide che si vede
      // (si misura il contenuto della slide: la slide stessa e' tirata all'altezza della piu' alta)
      if (opt.maxHeight === false && !media && slides[i] && slides[i].firstElementChild) {
        var slide = slides[i].firstElementChild;
        track.style.height = (slide.firstElementChild || slide).offsetHeight + 'px';
      }
      if (!opt.loop) {
        if (prev) prev.style.visibility = n > 1 && i > 0 ? '' : 'hidden';
        if (next) next.style.visibility = n > 1 && i < n - 1 ? '' : 'hidden';
      }
    }

    function vai(i) {
      var n = pagine();
      if (opt.loop) i = (i + n) % n;
      i = Math.max(0, Math.min(n - 1, i));
      track.scrollTo({ left: i * passo(), behavior: 'smooth' });
    }
    track.__mkVai = vai;

    if (prev) prev.addEventListener('click', function () { vai(indice() - 1); });
    if (next) next.addEventListener('click', function () { vai(indice() + 1); });
    var attesa;
    track.addEventListener('scroll', function () { clearTimeout(attesa); attesa = setTimeout(aggiorna, 60); }, { passive: true });
    window.addEventListener('resize', function () { costruisciPallini(); aggiorna(); });
    costruisciPallini();
    aggiorna();

    if (opt.autoPlay) {
      var fermo = false;
      if (opt.pauseOnHover) {
        track.addEventListener('pointerenter', function () { fermo = true; });
        track.addEventListener('pointerleave', function () { fermo = false; });
      }
      track.addEventListener('touchstart', function () { fermo = true; }, { passive: true });
      setInterval(function () {
        if (fermo || document.hidden || track.offsetParent === null) return;
        vai(indice() + 1 >= pagine() ? 0 : indice() + 1);
      }, opt.autoPlayDelay || 3000);
    }
  }

  // ---------- galleria prodotto: miniatura -> foto grande ----------
  function galleria(radice) {
    if (radice.__mk) return;
    radice.__mk = true;
    radice.classList.remove('product-media-loading');
    var grande = radice.querySelector('.pf-main-media .pf-media-slider');
    var mini = radice.querySelectorAll('.pf-slide-list-media');
    mini.forEach(function (m, i) {
      m.addEventListener('click', function () {
        mini.forEach(function (x) { x.setAttribute('data-active', x === m ? 'true' : 'false'); });
        if (grande && grande.__mkVai) grande.__mkVai(i);
      });
    });
    if (grande) grande.addEventListener('scroll', function () {
      var slides = grande.querySelectorAll('.pf-slide-main-media');
      var p = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : grande.clientWidth;
      var i = p > 0 ? Math.round(grande.scrollLeft / p) : 0;
      mini.forEach(function (x, k) { x.setAttribute('data-active', k === i ? 'true' : 'false'); });
    }, { passive: true });
  }

  // ---------- FAQ (Accordion con bottoni; le Accordion3 usano <details> nativo) ----------
  function accordion(acc) {
    if (acc.__mk) return;
    acc.__mk = true;
    var multipli = acc.getAttribute('data-multiple') === 'true';
    acc.querySelectorAll('[data-mk-type="Accordion.Header"]').forEach(function (h) {
      h.addEventListener('click', function () {
        var aperto = h.getAttribute('data-active') === 'true';
        if (!multipli) acc.querySelectorAll('[data-mk-type="Accordion.Header"]').forEach(function (x) {
          if (x !== h) { x.setAttribute('data-active', 'false'); var c = contenuto(x); if (c) c.style.display = 'none'; }
        });
        h.setAttribute('data-active', aperto ? 'false' : 'true');
        var c = contenuto(h);
        if (c) c.style.display = aperto ? 'none' : '';
      });
    });
    function contenuto(h) {
      var id = h.getAttribute('data-header-id');
      return acc.querySelector('[data-mk-type="Accordion.Content"][data-id="' + id + '"]');
    }
  }

  // ---------- bottoni "vai alle offerte" ----------
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-to-section]');
    if (!a) return;
    var dest = document.querySelector('[data-section-id="' + a.getAttribute('data-to-section') + '"]');
    if (!dest || dest.offsetParent === null) return;
    e.preventDefault();
    var off = 50;
    try { off = JSON.parse(a.getAttribute('data-offset')).all || 50; } catch (err) {}
    window.scrollTo({ top: dest.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
  });

  function avvia(radice) {
    radice.querySelectorAll('.pf-slider, .pf-media-slider').forEach(slider);
    radice.querySelectorAll('.product-media2-inner').forEach(galleria);
    radice.querySelectorAll('[data-mk-type="Accordion"]').forEach(accordion);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { avvia(document); });
  else avvia(document);
  // editor del tema: sezione aggiunta o modificata
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();
